import api_config from '../config/api'

export default {
	async getFooter() {
		return api_config.get(`api/footer`)
	},
}
